interface BaseAssetSource {
    name: string;
}

export interface GeneralAssetSource extends BaseAssetSource {
    type: string;
}

export interface FrameAssetSource extends BaseAssetSource {
    type: 'iframe';
    url: string;
}

export type AssetSource = FrameAssetSource | GeneralAssetSource;

export const CLOUDINARY_SOURCE = {
    name: 'cloudinary',
    type: 'cloudinary'
};

export const BYNDER_SOURCE = {
    name: 'bynder',
    type: 'bynder'
};

export const APRIMO_SOURCE = {
    name: 'aprimo',
    type: 'aprimo'
};

export const INTERNAL_SOURCE = {
    type: 'content-source-assets',
    name: 'content-source-assets'
};
